import {
  Container,
  Row,
  Col,
  Card,
  Badge,
} from "react-bootstrap";
const ExpertiseSection = ({ expertiseSection, menuId, themeColor }) => {
  return (
    <div style={{background: `linear-gradient(180deg, ${themeColor} -700%, #eef2ff30)`}}>
      <div id={menuId} className="py-5">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <h2 className="fw-bold">{expertiseSection?.expertiseSectionTitle}</h2>
              <p className="text-muted fs-5 mt-2">
                {expertiseSection?.expertiseSectionSubTitle}
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            {(expertiseSection?.expertise || [])?.map(item => (
              <Col md={6}>
                <Card className="border-0 shadow-sm rounded-4 h-100">
                  <Card.Body>
                    <h4 className="fw-bold mb-3">{item?.title}</h4>
                    <p className="text-muted">
                      {item?.description}
                    </p>
                    {(item?.points || [])?.length > 0 &&
                      <ul style={{ fontSize: 14 }} className="text-muted">
                        {(item?.points || [])?.map(point => (
                          <li>
                            {point}
                          </li>
                        ))}
                      </ul>
                    }
                    <div className="mt-3">
                      {(item?.highlights || [])?.length > 0 &&
                        <div style={{ fontSize: 13 }} className="mt-3">
                          {(item?.highlights || []).map((highlight) => (
                            <div className="badge me-2 mb-2" style={{backgroundColor: themeColor, borderColor: themeColor}}>
                              {highlight}
                            </div>
                          ))}
                        </div>
                      }
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default ExpertiseSection;
